import { Text, type TextProps } from "@mantine/core"
import { Markdown } from "@/components"
import type { TSurveyQuestion } from "@/types"

export function QuestionNote({ question, ...props }: { question: TSurveyQuestion } & TextProps) {
  if (!question.note) return null

  return (
    <Text c="dimmed" {...props}>
      <Markdown>{question.note}</Markdown>
    </Text>
  )
}
